import { FC, memo, useMemo } from 'react'
import MasonryCardComponent from './MasonryCard'
import * as S from './styles'
import { GalleryItemProps } from './types'

type MasonryColumnProps = {
  images: GalleryItemProps
  columnSet: number[]
  isLastColumn: boolean
  gap: number
}

const MasonryColumn: FC<MasonryColumnProps> = ({ images = [], columnSet = [], isLastColumn, gap }) => {
  const filteredImages = useMemo(() => columnSet.map((imageIndex: number) => images[imageIndex]), [images])

  return (
    <>
      <S.Column gap={gap}>
        {filteredImages.map((item) => (
          <MasonryCardComponent key={item.image.id} item={item} isLastColumn={isLastColumn} />
        ))}
      </S.Column>
    </>
  )
}

export default memo(MasonryColumn)
